import { z } from 'zod';
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    perPage: z.coerce.number().int().min(1).max(100).default(20),
});
export function paginate(data, total, query) {
    return {
        data,
        meta: {
            page: query.page,
            perPage: query.perPage,
            total,
            totalPages: Math.max(1, Math.ceil(total / query.perPage)),
        },
    };
}
//# sourceMappingURL=pagination.js.map